import React, {PureComponent} from 'react';
import {Icon} from '@material-ui/core';
import {I18n} from 'react-redux-i18n';

export default class RecordCounter extends PureComponent {
  render() {
    return (
      <div className="dvrcard__counter"><Icon>web_out_lined</Icon><span>{this.props.records} {I18n.t('page.dvrHealth.registerCounter')}</span></div>
    );
  }
}

